<template>
	<div class="w-full flex flex-col items-center">
		<ToolBar>
			<div
				id="tab-list"
				class="h-full flex-1 justify-center"
			>
				<template v-if="selectedPartnership?.billing_type === 'tiss'">
					<a
						class="tab-item"
						:class="{
							active: selectedGuide === 'consultation',
						}"
						:disabled="selectedGuide !== 'consultation'"
						@click="SelectGuide('consultation')"
						>CONSULTA
					</a>
					<a
						class="tab-item"
						:class="{
							active: selectedGuide === 'sp_sadt',
						}"
						:disabled="selectedGuide !== 'sp_sadt'"
						@click="SelectGuide('sp_sadt')"
						>SP/SADT
					</a>
					<a
						class="tab-item"
						disabled
						>HONORÁRIO
					</a>
					<a
						class="tab-item"
						disabled
						>INTERNAÇÃO
					</a>
					<a
						class="tab-item"
						disabled
						>ODONTOLOGIA
					</a>
					<a
						class="tab-item"
						disabled
						>RECURSOS GLOSADOS
					</a>
				</template>
				<template v-else>
					<a
						class="tab-item"
						:class="{
							active: selectedGuide === 'default',
						}"
						:disabled="selectedGuide !== 'default'"
						@click="SelectGuide('default')"
						>PADRÃO
					</a>
					<a
						class="tab-item"
						:class="{
							active: selectedGuide === 'none',
						}"
						:disabled="selectedGuide !== 'none'"
						@click="SelectGuide('none')"
						>NULO
					</a>
				</template>
			</div>
		</ToolBar>

		<MainContent class="w-full flex-1 py-4 px-4 gap-5">
			<Section
				v-model="open.partnership"
				title="CONVÊNIO"
			>
				<FormGroup
					v-model.trim="selected.partnership_id"
					class="w-full"
					label="CONVÊNIO"
					input-type="select"
					:required="true"
					:options="
						partnerships.map(p => ({
							...p,
							label: p.nome.toUpperCase(),
							value: p.id,
						}))
					"
					:input-classes="[
						{
							'field-error': submitted && !selectedPartnership,
						},
					]"
					placeholder="SELECIONE UM CONVÊNIO..."
					:readonly="true"
				/>
			</Section>
			<Section
				v-model="open.patient_data"
				title="DADOS DO PACIENTE"
			>
				<div class="data-group">
					<FormGroup
						v-model.trim="form.patient_data.wallet_number"
						class="w-full md:w-4/12"
						label="Nº CARTEIRA"
						formatter="alphanumeric"
						placeholder="DIGITE O Nº DA CARTEIRA"
						:required="isRequired('wallet_number', 'patient_data')"
						:disabled="disabled.patient_data.wallet_number"
						:input-classes="[
							{
								'field-error': !validations.patient_data.wallet_number,
							},
						]"
					/>
					<FormGroup
						v-model.trim="form.patient_data.wallet_validity"
						class="w-full md:w-4/12"
						label="VALIDADE CARTEIRA"
						input-type="date"
						placeholder="DD/MM/AAAA"
						:required="isRequired('wallet_validity', 'patient_data')"
						:disabled="disabled.patient_data.wallet_validity"
						:input-classes="[
							{
								'date-wrapper--error': !validations.patient_data.wallet_validity,
							},
						]"
					/>
					<FormGroup
						v-model.trim="form.patient_data.plan_registration"
						class="w-full md:w-4/12"
						label="MATRÍCULA DO PLANO"
						:required="isRequired('plan_registration', 'patient_data')"
						:disabled="disabled.patient_data.plan_registration"
						:input-classes="[
							{
								'field-error': !validations.patient_data.plan_registration,
							},
						]"
						placeholder="DIGITE A MATRÍCULA"
					/>
				</div>
			</Section>
			<Section
				v-model="open.indicator"
				title="SOLICITANTE"
			>
				<FormGroup
					v-model.trim="form.indicator.indicator_id"
					class="w-full"
					label="SOLICITANTE"
					input-type="select"
					:options="
						indicators.map(i => ({
							...i,
							label: i.name.toUpperCase(),
							value: i.id,
						}))
					"
					:required="isIndicatorRequired"
					:disabled="disabled.indicator.indicator"
					:input-classes="[
						{
							'field-error': !isIndicatorValid,
						},
					]"
					placeholder="PESQUISAR POR NOME, CONSELHO OU CPF..."
				>
					<template #buttons>
						<button
							type="button"
							class="btn btn-light btn-new-indicator flex-1"
							:disabled="disabled.indicator.indicator"
							@click="OpenNewIndicatorModal"
						>
							<i class="fa fa-plus"></i>
						</button>
					</template>
					<template #option="{ option }">
						<div class="font-weight-bold">
							{{ option.name.toUpperCase() }}
						</div>
						<small
							v-if="
								option.professional_advice_description &&
								option.number &&
								option.uf_professional_advice &&
								option.cpf
							"
							>{{ option.professional_advice_description.toUpperCase() }}
							-
							{{ option.uf_professional_advice }}: {{ option.number }} - CPF: {{ option.cpf }}</small
						>
						<small v-else-if="option.professional_advice_description && option.number && option.cpf"
							>{{ option.professional_advice_description.toUpperCase() }}: {{ option.number }} - CPF:
							{{ option.cpf }}
						</small>
						<small v-else-if="option.cpf"> CPF: {{ option.cpf }} </small>
					</template>
				</FormGroup>
			</Section>
			<Section
				v-model="open.guardian_data"
				title="RESPONSÁVEL LEGAL (MENOR OU INCAPAZ)"
			>
				<div class="data-group">
					<FormGroup
						v-model.trim="form.guardian_data.guardian_name"
						class="w-full md:w-6/12"
						label="NOME COMPLETO DO RESPONSÁVEL"
						:required="isRequired('guardian_name', 'guardian_data')"
						formatter="letters"
						:input-classes="[
							{
								'field-error': !validations.guardian_data.guardian_name,
							},
						]"
						placeholder="NOME DE QUEM ASSINA A GUIA"
					/>
					<FormGroup
						v-model.trim="form.guardian_data.guardian_cpf"
						class="w-full md:w-6/12"
						label="CPF DO RESPONSÁVEL"
						:required="isRequired('guardian_cpf', 'guardian_data')"
						formatter="cpf"
						:max-length="14"
						:input-classes="[
							{
								'field-error force': !validations.guardian_data.guardian_cpf,
							},
						]"
						placeholder="000.000.000-00"
					/>
				</div>
				<div class="data-group">
					<FormGroup
						v-model.trim="form.guardian_data.kinship_degree"
						class="w-full md:w-6/12"
						label="GRAU DE PARENTESCO"
						input-type="select"
						:required="isRequired('kinship_degree', 'guardian_data')"
						:disabled="disabled.guardian_data.kinship_degree"
						:options="
							constants.KINSHIP_DEGREE.map(k => ({
								...k,
								label: `${k.code} - ${k.label}`.toUpperCase(),
								value: k.code,
							}))
						"
						:input-classes="[
							{
								'field-error': !validations.guardian_data.kinship_degree,
							},
						]"
						placeholder="SELECIONE"
					>
						<template #tooltip>
							<ul class="info-modal-list">
								<li
									v-for="(info, idx) in GetInfoList('KINSHIP_DEGREE')"
									:key="idx"
									class="info-modal-item"
								>
									{{ info }}
								</li>
							</ul>
						</template>
					</FormGroup>
					<div class="w-full md:w-6/12">
						<FormGroup
							v-model.trim="form.guardian_data.guardian_phone"
							class="w-full"
							label="TELEFONE"
							:required="isRequired('guardian_phone', 'guardian_data')"
							formatter="phone"
							:max-length="15"
							:input-classes="[
								{
									'field-error force': !validations.guardian_data.guardian_phone,
								},
							]"
							placeholder="(00) 00000-0000"
						/>
					</div>
				</div>
			</Section>
			<Section
				v-model="open.authorization_data"
				title="DADOS DA AUTORIZAÇÃO"
			>
				<div class="data-group">
					<FormGroup
						v-model.trim="form.authorization_data.guide_number"
						class="w-full md:w-3/12"
						label="Nº GUIA OPERADORA"
						formatter="alphanumeric"
						:required="isRequired('guide_number', 'authorization_data')"
						:disabled="disabled.authorization_data.guide_number"
						:input-classes="[
							{
								'field-error': !validations.authorization_data.guide_number,
							},
						]"
						placeholder="DIGITE O Nº DA GUIA"
					/>
					<FormGroup
						v-model.trim="form.authorization_data.authorization"
						class="w-full md:w-3/12"
						label="AUTORIZAÇÃO"
						formatter="alphanumeric"
						:required="isRequired('authorization', 'authorization_data')"
						:disabled="disabled.authorization_data.authorization"
						:input-classes="[
							{
								'field-error': !validations.authorization_data.authorization,
							},
						]"
						placeholder="DIGITE O TOKEN"
					/>
					<FormGroup
						v-model.trim="form.authorization_data.authorization_validity"
						class="w-full md:w-3/12"
						label="VALIDADE DA AUTORIZAÇÃO"
						input-type="date"
						placeholder="DD/MM/AAAA"
						:required="isRequired('authorization_validity', 'authorization_data')"
						:disabled="disabled.authorization_data.authorization_validity"
						:input-classes="[
							{
								'date-wrapper--error': !validations.authorization_data.authorization_validity,
							},
						]"
					/>
					<FormGroup
						v-model.trim="form.authorization_data.authorization_date"
						class="w-full md:w-3/12"
						label="DATA DA AUTORIZAÇÃO"
						input-type="date"
						placeholder="DD/MM/AAAA"
						:required="isRequired('authorization_date', 'authorization_data')"
						:disabled="disabled.authorization_data.authorization_date"
						:input-classes="[
							{
								'date-wrapper--error': !validations.authorization_data.authorization_date,
							},
						]"
					/>
				</div>
				<div class="data-group">
					<FormGroup
						v-model.trim="form.authorization_data.validation_code"
						class="w-full md:w-4/12"
						formatter="alphanumeric"
						label="CÓDIGO DE VALIDAÇÃO"
						:required="isRequired('validation_code', 'authorization_data')"
						:disabled="disabled.authorization_data.validation_code || isAbsenceJustificationFilled"
						:input-classes="[
							{
								'field-error': !validations.authorization_data.validation_code,
							},
						]"
						placeholder="CÓDIGO DE VALIDAÇÃO"
					/>
					<FormGroup
						v-model.trim="form.authorization_data.absence_justification"
						class="w-full md:w-8/12"
						label="JUSTIFICATIVA DA AUSÊNCIA"
						input-type="select"
						:required="isRequired('absence_justification', 'authorization_data')"
						:disabled="disabled.authorization_data.absence_justification || isValidationCodeFilled"
						:options="
							constants.ABSENCE_JUSTIFICATION.map(a => ({
								...a,
								label: `${a.code} - ${a.label}`.toUpperCase(),
								value: a.code,
							}))
						"
						:input-classes="[
							{
								'field-error': !validations.authorization_data.absence_justification,
							},
						]"
						placeholder="SELECIONE"
					/>
				</div>
				<div class="data-group">
					<FormGroup
						v-model.trim="form.authorization_data.provider_guide_number"
						class="w-full md:w-6/12"
						label="Nº GUIA NO PRESTADOR"
						formatter="alphanumeric"
						:required="isRequired('provider_guide_number', 'authorization_data')"
						:disabled="disabled.authorization_data.provider_guide_number"
						:input-classes="[
							{
								'field-error': !validations.authorization_data.provider_guide_number,
							},
						]"
						placeholder=" "
						:readonly="true"
					/>
					<FormGroup
						v-model.trim="form.authorization_data.main_guide_number"
						class="w-full md:w-6/12"
						label="Nº GUIA PRINCIPAL"
						formatter="numbers"
						:required="isRequired('main_guide_number', 'authorization_data')"
						:disabled="disabled.authorization_data.main_guide_number"
						:max-length="20"
						:input-classes="[
							{
								'field-error': !validations.authorization_data.main_guide_number,
							},
						]"
						placeholder="Nº DA GUIA PRINCIPAL"
					/>
				</div>
			</Section>
			<Section
				v-model="open.attendance_details"
				title="DETALHES DO ATENDIMENTO"
			>
				<div class="data-group">
					<FormGroup
						v-model.trim="form.attendance_details.request_date"
						class="w-full md:w-4/12"
						label="DATA DA SOLICITAÇÃO"
						input-type="date"
						placeholder="DD/MM/AAAA"
						:required="isRequired('request_date', 'attendance_details')"
						:disabled="disabled.attendance_details.request_date"
						:input-classes="[
							{
								'date-wrapper--error': !validations.attendance_details.request_date,
							},
						]"
					/>
					<FormGroup
						v-model.trim="form.attendance_details.attendance_type"
						class="w-full md:w-4/12"
						label="TIPO DE ATENDIMENTO"
						input-type="select"
						:input-classes="[
							{
								'field-error': !validations.attendance_details.attendance_type,
							},
						]"
						:required="isRequired('attendance_type', 'attendance_details')"
						:disabled="disabled.attendance_details.attendance_type"
						:options="
							constants.ATTENDANCE_TYPE.map(a => ({
								...a,
								label: `${a.code} - ${a.label}`,
								value: a.code,
							}))
						"
						placeholder="SELECIONE"
					>
						<template #tooltip>
							<ul class="info-modal-list">
								<li
									v-for="(info, idx) in GetInfoList('ATTENDANCE_TYPE')"
									:key="idx"
									class="info-modal-item"
								>
									{{ info }}
								</li>
							</ul>
						</template>
					</FormGroup>
					<FormGroup
						v-model.trim="form.attendance_details.attendance_character"
						class="w-full md:w-4/12"
						label="CARÁTER ATENDIMENTO"
						input-type="select"
						:input-classes="[
							{
								'field-error': !validations.attendance_details.attendance_character,
							},
						]"
						:required="isRequired('attendance_character', 'attendance_details')"
						:disabled="disabled.attendance_details.attendance_character"
						:options="
							constants.ATTENDANCE_CHARACTER.map(a => ({
								...a,
								label: `${a.code} - ${a.label}`.toUpperCase(),
								value: a.code,
							}))
						"
						placeholder="SELECIONE"
					/>
				</div>
				<div class="data-group">
					<FormGroup
						v-model.trim="form.attendance_details.regime"
						class="w-full md:w-4/12"
						label="REGIME"
						input-type="select"
						:input-classes="[
							{
								'field-error': !validations.attendance_details.regime,
							},
						]"
						:required="isRequired('regime', 'attendance_details')"
						:disabled="disabled.attendance_details.regime"
						:options="
							constants.REGIME.map(a => ({
								...a,
								label: `${a.code} - ${a.label}`.toUpperCase(),
								value: a.code,
							}))
						"
						placeholder="SELECIONE"
					>
						<template #tooltip>
							<ul class="info-modal-list">
								<li
									v-for="(info, idx) in GetInfoList('REGIME')"
									:key="idx"
									class="info-modal-item"
								>
									{{ info }}
								</li>
							</ul>
						</template>
					</FormGroup>
					<FormGroup
						v-model.trim="form.attendance_details.consultation_type"
						class="w-full md:w-4/12"
						label="TIPO DE CONSULTA"
						input-type="select"
						:input-classes="[
							{
								'field-error': !validations.attendance_details.consultation_type,
							},
						]"
						:required="isRequired('consultation_type', 'attendance_details')"
						:disabled="disabled.attendance_details.consultation_type"
						:options="
							constants.CONSULTATION_TYPE.map(a => ({
								...a,
								label: `${a.code} - ${a.label}`.toUpperCase(),
								value: a.code,
							}))
						"
						placeholder="SELECIONE"
					/>
					<FormGroup
						v-model.trim="form.attendance_details.special_coverage"
						class="w-full md:w-4/12"
						label="COBERTURA ESPECIAL"
						input-type="select"
						:input-classes="[
							{
								'field-error': !validations.attendance_details.special_coverage,
							},
						]"
						:required="isRequired('special_coverage', 'attendance_details')"
						:disabled="disabled.attendance_details.special_coverage"
						:options="
							constants.SPECIAL_COVERAGE.map(a => ({
								...a,
								label: `${a.code} - ${a.label}`.toUpperCase(),
								value: a.code,
							}))
						"
						placeholder="SELECIONE"
					/>
				</div>
				<div class="data-group">
					<FormGroup
						v-model.trim="form.attendance_details.occupational_health"
						class="w-full md:w-6/12"
						label="SAÚDE OCUPACIONAL"
						input-type="select"
						:input-classes="[
							{
								'field-error': !validations.attendance_details.occupational_health,
							},
						]"
						:required="isRequired('occupational_health', 'attendance_details')"
						:disabled="disabled.attendance_details.occupational_health"
						:options="
							constants.OCCUPATIONAL_HEALTH.map(a => ({
								...a,
								label: `${a.code} - ${a.label}`.toUpperCase(),
								value: a.code,
							}))
						"
						placeholder="SELECIONE"
					>
						<template #tooltip>
							<ul class="info-modal-list">
								<li
									v-for="(info, idx) in GetInfoList('OCCUPATIONAL_HEALTH')"
									:key="idx"
									class="info-modal-item"
								>
									{{ info }}
								</li>
							</ul>
						</template>
					</FormGroup>
					<FormGroup
						v-model.trim="form.attendance_details.accident_indication"
						class="w-full md:w-6/12"
						label="INDICAÇÃO DE ACIDENTE"
						input-type="select"
						:input-classes="[
							{
								'field-error': !validations.attendance_details.accident_indication,
							},
						]"
						:required="isRequired('accident_indication', 'attendance_details')"
						:disabled="disabled.attendance_details.accident_indication"
						:options="
							constants.ACCIDENT_INDICATION.map(a => ({
								...a,
								label: `${a.code} - ${a.label}`.toUpperCase(),
								value: a.code,
							}))
						"
						placeholder="SELECIONE"
					>
						<template #tooltip>
							<ul class="info-modal-list">
								<li
									v-for="(info, idx) in GetInfoList('ACCIDENT_INDICATION')"
									:key="idx"
									class="info-modal-item"
								>
									{{ info }}
								</li>
							</ul>
						</template>
					</FormGroup>
				</div>
				<div class="w-full">
					<FormGroup
						v-model.trim="form.attendance_details.cid"
						class="w-full"
						label="INDICAÇÃO CLÍNICA (CID-10)"
						input-type="select"
						:input-classes="[
							{
								'field-error': !validations.attendance_details.cid,
							},
						]"
						:required="isRequired('cid', 'attendance_details')"
						:disabled="disabled.attendance_details.cid"
						:options="
							constants.CIDS.map(a => ({
								...a,
								label: `${a.code} - ${a.label}`.toUpperCase(),
								value: a.code,
							}))
						"
						:min-length="2"
						placeholder="DIGITE O NÚMERO OU DESCRIÇÃO DO CID-10"
					/>
				</div>
				<div class="w-full">
					<FormGroup
						v-model.trim="form.attendance_details.observations"
						class="w-full"
						label="OBSERVAÇÕES"
						input-type="textarea"
						:max-length="500"
						:input-classes="[
							{
								'field-error': !validations.attendance_details.observations,
							},
						]"
						:required="isRequired('observations', 'attendance_details')"
						:disabled="disabled.attendance_details.observations"
						placeholder="DIGITE AS OBSERVAÇÕES"
					/>
				</div>
			</Section>

			<IndicatorModal
				ref="indicatorModal"
				@indicator="OnIndicatorSelected"
			/>
		</MainContent>
	</div>
</template>

<script>
	import _ from 'lodash'
	import { mapGetters, mapActions } from 'vuex'

	import Title from '@/components/shared/layout/Title'
	import IndicatorModal from '@/components/shared/indicator/IndicatorModal.vue'

	import {
		ABSENCE_JUSTIFICATION,
		KINSHIP_DEGREE,
		ATTENDANCE_TYPE,
		ATTENDANCE_CHARACTER,
		REGIME,
		CONSULTATION_TYPE,
		SPECIAL_COVERAGE,
		OCCUPATIONAL_HEALTH,
		ACCIDENT_INDICATION,
		CIDS,
		SCHEDULE_TYPES,
	} from '@/constants'
	import { INFOS } from '@/constants/Infos'

	export default {
		name: 'Guide',
		components: {
			Title,
			IndicatorModal,
		},
		props: {
			modality_id: {
				type: [String, Number],
				default: null,
			},
			partnership: {
				type: Object,
				default: null,
			},
			schedule_type: {
				type: Number,
				default: null,
			},
			billing: {
				type: Object,
				default: null,
			},
			schedulings: {
				type: Array,
				default: () => [],
			},
			allowed_partnership_ids: {
				type: Array,
				default: null,
			},
			partnerships: {
				type: Array,
				default: () => [],
			},
			indicator: {
				type: Object,
				default: null,
			},
			patient: {
				type: Object,
				default: null,
			},
			type: {
				type: String,
				default: 'scheduling',
			},
			isNewGuide: {
				type: Boolean,
				default: false,
			},
		},
		data() {
			return {
				indicators: [],
				selected: {
					partnership_id: null,
					indicator: null,
				},
				form: {
					patient_data: {
						wallet_number: '',
						wallet_validity: '',
						plan_registration: '',
					},
					indicator: {
						indicator_id: null,
					},
					guardian_data: {
						guardian_name: '',
						guardian_cpf: '',
						kinship_degree: '',
						guardian_phone: '',
					},
					authorization_data: {
						guide_number: '',
						authorization: '',
						authorization_validity: '',
						authorization_date: '',
						validation_code: '',
						absence_justification: '',
						provider_guide_number: '',
						main_guide_number: '',
					},
					attendance_details: {
						request_date: '',
						attendance_type: null,
						attendance_character: '',
						regime: '',
						consultation_type: '',
						special_coverage: '',
						occupational_health: '',
						accident_indication: '',
						cid: '',
						observations: '',
					},
				},
				constants: {
					ABSENCE_JUSTIFICATION,
					KINSHIP_DEGREE,
					ATTENDANCE_TYPE,
					ATTENDANCE_CHARACTER,
					REGIME,
					CONSULTATION_TYPE,
					SPECIAL_COVERAGE,
					OCCUPATIONAL_HEALTH,
					ACCIDENT_INDICATION,
					CIDS,
				},
				cidSearch: '',
				cidDropdownVisible: false,
				cidHighlight: 0,
				infos: {},
				infoModal: {
					show: false,
					type: null,
					direction: 'down',
				},
				submitted: false,
				selectedBillingType: 'default',
				selectedGuide: 'default',
				open: {
					partnership: true,
					authorization_data: false,
					patient_data: false,
					guardian_data: false,
					attendance_details: false,
					indicator: false,
				},
				disabled: {
					authorization_data: {
						guide_number: false,
						authorization: false,
						authorization_validity: false,
						authorization_date: false,
						validation_code: true,
						absence_justification: true,
						provider_guide_number: false,
						main_guide_number: false,
					},
					patient_data: {
						wallet_number: false,
						wallet_validity: false,
						plan_registration: false,
					},
					guardian_data: {
						guardian_name: false,
						guardian_cpf: false,
						kinship_degree: false,
						guardian_phone: false,
					},
					attendance_details: {
						request_date: false,
						attendance_type: false,
						attendance_character: false,
						regime: false,
						consultation_type: false,
						special_coverage: false,
						occupational_health: false,
						accident_indication: false,
						cid: false,
						observations: false,
					},
					indicator: {
						indicator: false,
					},
				},
				syncing: false,
				updabeBillingTimer: null,
			}
		},
		computed: {
			...mapGetters('system', ['modules', 'modalities']),
			...mapGetters('auth', ['requester_selected_id', 'requester_selected_object']),
			isPreAppointment() {
				return this.type === 'scheduling' && this.schedule_type === SCHEDULE_TYPES.PRE_APPOINTMENT
			},
			filteredCids() {
				if (!this.cidSearch.trim()) return []
				const q = this.cidSearch.trim().toLowerCase()
				return this.constants.CIDS.filter(
					o => o.code.toLowerCase().includes(q) || o.label.toLowerCase().includes(q)
				).slice(0, 20)
			},
			isIndicatorRequired() {
				if (this.disabled.indicator.indicator) return false

				return !!this.selectedPartnership?.indicator
			},
			selectedPartnership() {
				return this.partnerships.find(p => p.id === parseInt(this.selected.partnership_id))
			},
			isTiss() {
				return this.selectedPartnership?.billing_type === 'tiss'
			},
			isDifferentPartnership() {
				if (!this.billing?.partnership_id || (!this.partnership?.id && !this.selected.partnership_id))
					return false
				const currentPartnershipId = this.partnership?.id ?? this.selected.partnership_id
				return parseInt(this.billing.partnership_id) !== parseInt(currentPartnershipId)
			},
			selectedIndicator() {
				return this.indicators.find(i => i.id === parseInt(this.form.indicator.indicator_id)) ?? null
			},
			isGuardianRequired() {
				return this.selectedBillingType === 'tiss' && (!!this.patient.uncapable || !!this.patient.newborn)
			},
			isValidationCodeRequired() {
				if (!this.selectedPartnership) return true

				return this.selectedPartnership.validation_code
			},
			isValidationCodeFilled() {
				return !!this.form.authorization_data.validation_code
			},
			isAbsenceJustificationFilled() {
				return !!this.form.authorization_data.absence_justification
			},
			// Form Validations
			validations() {
				if (this.isPreAppointment || !this.submitted || !this.selectedPartnership) {
					return {
						authorization_data: {
							guide_number: true,
							authorization: true,
							authorization_validity: true,
							authorization_date: true,
							validation_code: true,
							absence_justification: true,
							provider_guide_number: true,
							main_guide_number: true,
						},
						patient_data: {
							wallet_number: true,
							wallet_validity: true,
							plan_registration: true,
						},
						guardian_data: {
							guardian_name: true,
							guardian_cpf: true,
							kinship_degree: true,
							guardian_phone: true,
						},
						attendance_details: {
							request_date: true,
							attendance_type: true,
							attendance_character: true,
							regime: true,
							consultation_type: true,
							special_coverage: true,
							occupational_health: true,
							accident_indication: true,
							cid: true,
							observations: true,
						},
						indicator: {
							indicator: true,
						},
					}
				}

				return {
					authorization_data: {
						guide_number: this.isGuideNumberValid,
						authorization: this.isAuthorizationValid,
						authorization_validity: this.isAuthorizationValidityValid,
						authorization_date: this.isAuthorizationDateValid,
						validation_code: this.isValidationCodeValid,
						absence_justification: this.isAbsenceJustificationValid,
						provider_guide_number: this.isProviderGuideNumberValid,
						main_guide_number: this.isMainGuideNumberValid,
					},
					patient_data: {
						wallet_number: this.isWalletNumberValid,
						wallet_validity: this.isWalletValidityValid,
						plan_registration: this.isPlanRegistrationValid,
					},
					guardian_data: {
						guardian_name: this.isGuardianNameValid,
						guardian_cpf: this.isGuardianCpfValid,
						kinship_degree: this.isKinshipDegreeValid,
						guardian_phone: this.isGuardianPhoneValid,
					},
					attendance_details: {
						request_date: this.isRequestDateValid,
						attendance_type: this.isAttendanceTypeValid,
						attendance_character: this.isAttendanceCharacterValid,
						regime: this.isRegimeValid,
						consultation_type: this.isConsultationTypeValid,
						special_coverage: this.isSpecialCoverageValid,
						occupational_health: this.isOccupationalHealthValid,
						accident_indication: this.isAccidentIndicationValid,
						cid: this.isCidValid,
						observations: this.isObservationsValid,
					},
					indicator: {
						indicator: this.isIndicatorValid,
					},
				}
			},
			isGuideNumberValid() {
				if (this.disabled.authorization_data.guide_number) return true
				return !this.selectedPartnership.guide_number ? true : !!this.form.authorization_data.guide_number
			},
			isAuthorizationValid() {
				if (this.disabled.authorization_data.authorization) return true
				return !this.selectedPartnership.authorization ? true : !!this.form.authorization_data.authorization
			},
			isAuthorizationValidityValid() {
				if (this.disabled.authorization_data.authorization_validity) return true
				return !this.selectedPartnership.authorization_validity
					? true
					: !!this.form.authorization_data.authorization_validity
			},
			isAuthorizationDateValid() {
				if (this.disabled.authorization_data.authorization_date) return true
				return !this.selectedPartnership.authorization_date
					? true
					: !!this.form.authorization_data.authorization_date
			},
			isValidationCodeValid() {
				if (this.disabled.authorization_data.validation_code) return true
				if (this.form.authorization_data.absence_justification) return true

				return !this.selectedPartnership.validation_code ? true : !!this.form.authorization_data.validation_code
			},
			isAbsenceJustificationValid() {
				if (this.disabled.authorization_data.absence_justification) return true
				if (this.form.authorization_data.validation_code) return true

				return !this.selectedPartnership.validation_code
					? true
					: !!this.form.authorization_data.absence_justification
			},
			isProviderGuideNumberValid() {
				if (this.disabled.authorization_data.provider_guide_number) return true
				return !this.selectedPartnership.provider_guide_number
					? true
					: !!this.form.authorization_data.provider_guide_number
			},
			isMainGuideNumberValid() {
				if (this.disabled.authorization_data.main_guide_number) return true
				return !this.selectedPartnership.main_guide_number ? true : !!this.form.authorization_data.main_guide_number
			},
			isWalletNumberValid() {
				if (this.disabled.patient_data.wallet_number) return true
				return !this.selectedPartnership.wallet_number ? true : !!this.form.patient_data.wallet_number
			},
			isWalletValidityValid() {
				if (this.disabled.patient_data.wallet_validity) return true
				return !this.selectedPartnership.wallet_validity ? true : !!this.form.patient_data.wallet_validity
			},
			isPlanRegistrationValid() {
				if (this.disabled.patient_data.plan_registration) return true
				return !this.selectedPartnership.plan_registration ? true : !!this.form.patient_data.plan_registration
			},
			isGuardianNameValid() {
				if (this.disabled.guardian_data.guardian_name) return true
				if (this.form.guardian_data.guardian_name) return true
				if (this.isGuardianRequired) return false

				const hasGuardianCpf = this.form.guardian_data.guardian_cpf
				const hasKinshipDegree = this.form.guardian_data.kinship_degree
				const hasGuardianPhone = this.form.guardian_data.guardian_phone
				if (hasGuardianCpf || hasKinshipDegree || hasGuardianPhone) return false

				return !this.selectedPartnership.guardian_name ? true : !!this.form.guardian_data.guardian_name
			},
			isGuardianCpfValid() {
				if (this.disabled.guardian_data.guardian_cpf) return true
				const hasGuardianCpf = !!this.form.guardian_data.guardian_cpf
				if (hasGuardianCpf) return this.validCpf(this.form.guardian_data.guardian_cpf)
				if (this.isGuardianRequired) return false

				const hasGuardianName = this.form.guardian_data.guardian_name
				const hasKinshipDegree = this.form.guardian_data.kinship_degree
				const hasGuardianPhone = this.form.guardian_data.guardian_phone
				if (hasGuardianName || hasKinshipDegree || hasGuardianPhone) return false

				const requiredRule = this.selectedPartnership.guardian_cpf
				if (requiredRule) return false

				return true
			},
			isKinshipDegreeValid() {
				if (this.disabled.guardian_data.kinship_degree) return true
				if (this.form.guardian_data.kinship_degree) return true
				if (this.isGuardianRequired) return false
				const hasGuardianName = this.form.guardian_data.guardian_name
				const hasGuardianCpf = this.form.guardian_data.guardian_cpf
				const hasGuardianPhone = this.form.guardian_data.guardian_phone
				if (hasGuardianName || hasGuardianCpf || hasGuardianPhone) return false

				return !this.selectedPartnership.kinship_degree ? true : !!this.form.guardian_data.kinship_degree
			},
			isGuardianPhoneValid() {
				if (this.disabled.guardian_data.guardian_phone) return true
				const hasGuardianPhone = !!this.form.guardian_data.guardian_phone
				const minLength =
					this.form.guardian_data.guardian_phone && this.form.guardian_data.guardian_phone.length >= 14
				if (hasGuardianPhone && minLength) return true
				if (this.isGuardianRequired) return false

				const hasGuardianName = this.form.guardian_data.guardian_name
				const hasGuardianCpf = this.form.guardian_data.guardian_cpf
				const hasKinshipDegree = this.form.guardian_data.kinship_degree
				if (hasGuardianName || hasGuardianCpf || hasKinshipDegree) return false

				const requiredRule = this.selectedPartnership.guardian_phone
				if (requiredRule) return false

				return true
			},
			isRequestDateValid() {
				if (this.disabled.attendance_details.request_date) return true
				return !this.selectedPartnership.request_date ? true : !!this.form.attendance_details.request_date
			},
			isAttendanceTypeValid() {
				if (this.disabled.attendance_details.attendance_type) return true
				return !this.selectedPartnership.attendance_type
					? true
					: this.form.attendance_details.attendance_type !== null &&
							this.form.attendance_details.attendance_type !== undefined
			},
			isAttendanceCharacterValid() {
				if (this.disabled.attendance_details.attendance_character) return true
				return !this.selectedPartnership.attendance_character
					? true
					: !!this.form.attendance_details.attendance_character
			},
			isRegimeValid() {
				if (this.disabled.attendance_details.regime) return true
				return !this.selectedPartnership.regime ? true : !!this.form.attendance_details.regime
			},
			isConsultationTypeValid() {
				if (this.disabled.attendance_details.consultation_type) return true
				return !this.selectedPartnership.consultation_type
					? true
					: !!this.form.attendance_details.consultation_type
			},
			isSpecialCoverageValid() {
				if (this.disabled.attendance_details.special_coverage) return true
				return !this.selectedPartnership.special_coverage
					? true
					: !!this.form.attendance_details.special_coverage
			},
			isOccupationalHealthValid() {
				if (this.disabled.attendance_details.occupational_health) return true
				return !this.selectedPartnership.occupational_health
					? true
					: !!this.form.attendance_details.occupational_health
			},
			isAccidentIndicationValid() {
				if (this.disabled.attendance_details.accident_indication) return true
				return !this.selectedPartnership.accident_indication
					? true
					: !!this.form.attendance_details.accident_indication
			},
			isCidValid() {
				if (this.disabled.attendance_details.cid) return true
				return !this.selectedPartnership.cid ? true : !!this.form.attendance_details.cid
			},
			isObservationsValid() {
				if (this.disabled.attendance_details.observations) return true
				return !this.selectedPartnership.observations ? true : !!this.form.attendance_details.observations
			},
			isIndicatorValid() {
				if (!this.submitted) return true
				if (!this.isIndicatorRequired) return true

				if (this.form.indicator.indicator_id) return true

				return false
			},
			isFormValid() {
				if (!this.selectedPartnership) return false
				if (this.isPreAppointment) return true

				return (
					this.groupIsAuthorizationDatValid &&
					this.groupIsPatientDataValid &&
					this.groupIsGuardianDataValid &&
					this.groupIsAttendanceDetailsValid &&
					this.groupIsIndicatorValid
				)
			},
			groupIsAuthorizationDatValid() {
				if (!this.selectedPartnership) return true

				return (
					this.isGuideNumberValid &&
					this.isAuthorizationValid &&
					this.isAuthorizationValidityValid &&
					this.isAuthorizationDateValid &&
					this.isValidationCodeValid &&
					this.isAbsenceJustificationValid &&
					this.isProviderGuideNumberValid &&
					this.isMainGuideNumberValid
				)
			},
			groupIsPatientDataValid() {
				if (!this.selectedPartnership) return true

				return this.isWalletNumberValid && this.isWalletValidityValid && this.isPlanRegistrationValid
			},
			groupIsGuardianDataValid() {
				if (!this.selectedPartnership) return true

				return (
					this.isGuardianNameValid &&
					this.isGuardianCpfValid &&
					this.isKinshipDegreeValid &&
					this.isGuardianPhoneValid
				)
			},
			groupIsAttendanceDetailsValid() {
				if (!this.selectedPartnership) return true

				return (
					this.isRequestDateValid &&
					this.isAttendanceTypeValid &&
					this.isAttendanceCharacterValid &&
					this.isRegimeValid &&
					this.isConsultationTypeValid &&
					this.isSpecialCoverageValid &&
					this.isOccupationalHealthValid &&
					this.isAccidentIndicationValid &&
					this.isCidValid &&
					this.isObservationsValid
				)
			},
			groupIsIndicatorValid() {
				return this.isIndicatorValid
			},
		},
		watch: {
			partnership: {
				handler(val) {
					this.selected.partnership_id = val?.id ? parseInt(val.id) : null
				},
				immediate: true,
			},
			selectedPartnership: {
				handler(val) {
					if (!val) return
					this.selectedBillingType = val.billing_type || 'default'
					this.BillingTypeAndGuideHandler()
					this.ValidationCodeAndAbsenceHandler()
				},
				immediate: true,
			},
			form: {
				async handler() {
					if (this.syncing) return
					await this.$nextTick()
					this.UpdateBillingDebounce()
				},
				deep: true,
			},
			indicator: {
				handler(val) {
					if (val?.id) this.form.indicator.indicator_id = val.id
				},
				immediate: true,
			},
			selectedIndicator: {
				handler(val) {
					if (val && val?.id) this.$emit('indicator-change', val)
				},
				immediate: true,
				deep: true,
			},
			selectedGuide: {
				handler(val) {
					if (val === 'consultation') this.ConsultationGuideHandler()
					else this.SpSadtGuideHandler()
				},
				immediate: true,
			},
			isDifferentPartnership: {
				handler(val) {
					if (!val) return
					this.ClearPatientData()
					this.ClearIndicatorData()
					this.ClearAuthorizationData(false)
					this.ClearAttendanceDetailsData()
				},
				immediate: true,
			},
		},
		methods: {
			...mapActions('system', ['StartLoading', 'FinishLoading']),
			GetFlattenedBilling() {
				return {
					...this.form.authorization_data,
					...this.form.patient_data,
					...this.form.guardian_data,
					...this.form.attendance_details,
					billing_type: this.selectedBillingType,
					guide_type: this.selectedGuide,
					partnership_id:
						this.selectedPartnership?.id ??
						(this.selected.partnership_id ? parseInt(this.selected.partnership_id) : null),
				}
			},
			async PopulateFormFromBilling() {
				const billingData = this.billing

				if(billingData) {
					this.syncing = true
	
					const isDiff = this.isDifferentPartnership
					const isConsultation = this.selectedGuide === 'consultation'
	
					for (const group in this.form) {
						let shouldPopulate = false
	
						if (isDiff) {
							shouldPopulate = group === 'guardian_data'
						} else if (isConsultation && this.type === 'scheduling') {
							shouldPopulate = group === 'patient_data' || group === 'guardian_data'
						} else {
							shouldPopulate = true
						}
	
						if (shouldPopulate) {
							for (const field in this.form[group]) {
								const val =
									billingData[field] !== undefined ? billingData[field] : billingData[group]?.[field]
								if (val !== undefined && val !== null) {
									this.form[group][field] = val
								}
							}
						} else {
							this.ClearGroupData(group)
						}
					}
	
					if (!isDiff && !isConsultation && billingData.cid) {
						const found = this.constants.CIDS.find(c => c.code === billingData.cid)
						this.cidSearch = found ? `${found.code} - ${found.label}` : billingData.cid
					} else {
						this.cidSearch = ''
					}
	
					if (!isDiff && billingData.guide_type) this.selectedGuide = billingData.guide_type
				}

				await this.ProviderGuideNumberHandler()
				await this.$nextTick()
				this.syncing = false
			},
			ClearGroupData(group) {
				if (group === 'patient_data') this.ClearPatientData()
				else if (group === 'indicator') this.ClearIndicatorData()
				else if (group === 'guardian_data') this.ClearGuardianData()
				else if (group === 'authorization_data') this.ClearAuthorizationData()
				else if (group === 'attendance_details') this.ClearAttendanceDetailsData()
			},
			UpdateBillingDebounce() {
				if (this.updabeBillingTimer) clearTimeout(this.updabeBillingTimer)

				this.updabeBillingTimer = setTimeout(() => {
					const data = this.GetFlattenedBilling()
					this.$emit('billing-change', data)
				}, 500)
			},
			async ClearBillingData() {
				this.ClearPatientData()
				this.ClearIndicatorData()
				this.ClearGuardianData()
				this.ClearAuthorizationData()
				this.ClearAttendanceDetailsData()
			},
			ClearPatientData() {
				this.syncing = true

				this.form.patient_data = {
					wallet_number: '',
					wallet_validity: '',
					plan_registration: '',
				}

				this.$nextTick(() => {
					this.syncing = false
				})
			},
			ClearIndicatorData() {
				this.syncing = true

				this.form.indicator = {
					indicator_id: null,
				}

				this.$nextTick(() => {
					this.syncing = false
				})
			},
			ClearGuardianData() {
				this.syncing = true

				this.form.guardian_data = {
					guardian_name: '',
					guardian_cpf: '',
					kinship_degree: '',
					guardian_phone: '',
				}

				this.$nextTick(() => {
					this.syncing = false
				})
			},
			ClearAuthorizationData(clearProviderGuideNumber = true) {
				this.syncing = true

				this.form.authorization_data = {
					guide_number: '',
					authorization: '',
					authorization_validity: '',
					authorization_date: '',
					validation_code: '',
					absence_justification: '',
					main_guide_number: null,
				}

				if (clearProviderGuideNumber) {
					this.form.authorization_data.provider_guide_number = null
				}

				this.$nextTick(() => {
					this.syncing = false
				})
			},
			ClearAttendanceDetailsData() {
				this.syncing = true

				this.form.attendance_details = {
					request_date: '',
					attendance_type: null,
					attendance_character: '',
					regime: '',
					consultation_type: '',
					special_coverage: '',
					occupational_health: '',
					accident_indication: '',
					cid: '',
					observations: '',
				}

				this.$nextTick(() => {
					this.syncing = false
				})
			},
			validCpf(cpf) {
				return cpf !== '' && window.helpers.ValidaCPF(cpf)
			},
			isRequired(field, group = null) {
				if (field === 'partnership_id') return true
				if (group && this.disabled[group][field]) return false

				const guardianFields = ['guardian_name', 'guardian_cpf', 'kinship_degree', 'guardian_phone']
				if (guardianFields.includes(field)) {
					if (this.isGuardianRequired) return true

					const anyFilled = guardianFields.some(f => {
						const value = this.form.guardian_data[f]
						return value !== null && value !== undefined && String(value).trim() !== ''
					})

					return anyFilled
				}

				const partnership = this.partnerships.find(p => p.id === parseInt(this.selected.partnership_id))

				const validationCodeRequired = partnership?.validation_code === true

				if (field === 'validation_code') {
					if (!validationCodeRequired) {
						return false
					}

					return !String(this.form.authorization_data.absence_justification || '').trim()
				}

				if (field === 'absence_justification' && validationCodeRequired) {
					return !String(this.form.authorization_data.validation_code || '').trim()
				}

				if (partnership && typeof partnership[field] === 'boolean') {
					return partnership[field] === true
				}

				return false
			},
			OnCidInput() {
				this.form.attendance_details.cid = ''
				this.cidHighlight = 0
				this.cidDropdownVisible = this.cidSearch.trim().length > 0
			},
			OnCidBlur() {
				setTimeout(() => {
					this.cidDropdownVisible = false
				}, 150)
			},
			SelectCid(cid) {
				if (!cid) return
				this.form.attendance_details.cid = cid.code
				this.cidSearch = `${cid.code} - ${cid.label}`
				this.cidDropdownVisible = false
			},
			Previous() {
				this.$emit('previous')
			},
			SelectPartnership(partnership_id) {
				this.selected.partnership_id = partnership_id
			},
			OpenInfoModal(type, event) {
				if (this.infoModal.show && this.infoModal.type === type) {
					this.CloseInfoModal()
					return
				}
				document.removeEventListener('click', this.OnDocumentClick)
				const btn = event?.currentTarget
				const rect = btn ? btn.getBoundingClientRect() : null
				const spaceBelow = rect ? window.innerHeight - rect.bottom : 999
				this.infoModal.direction = spaceBelow < 665 ? 'up' : 'down'
				this.infoModal.type = type
				this.infoModal.show = true
				setTimeout(() => {
					document.addEventListener('click', this.OnDocumentClick)
				}, 0)
			},
			OnDocumentClick() {
				this.CloseInfoModal()
			},
			CloseInfoModal() {
				document.removeEventListener('click', this.OnDocumentClick)
				this.infoModal.show = false
				this.infoModal.type = null
			},
			async Continue() {
				this.submitted = true
				if (!this.isFormValid) {
					const hasOpenedGroups = await this.OpenInvalidGroups()
					await this.$nextTick()
					const firstError = this.$el.querySelector('.field-error, .vs--error, .date-wrapper--error')
					if (firstError) {
						setTimeout(
							() => {
								firstError.scrollIntoView({
									behavior: 'smooth',
									block: 'center',
								})
							},
							hasOpenedGroups ? 250 : 1
						)
					}
					return
				}

				this.$emit('next', {
					partnership: this.selectedPartnership,
					billing: this.GetFlattenedBilling(),
					indicator: this.selectedIndicator || null,
				})
			},
			OpenNewIndicatorModal() {
				window.jQuery('#indicator_modal').modal('show')
			},
			async OnIndicatorSelected(indicator) {
				this.selected.indicator = indicator
				window.jQuery('#indicator_modal').modal('hide')
				await this.GetIndicators()
			},
			async GetIndicators() {
				return window.api
					.call('post', '/get-indicators', {
						organization_id: this.requester_selected_id,
					})
					.then(({ data }) => {
						if (data.response) {
							this.indicators = data.indicators.slice().sort((a, b) => a.name.localeCompare(b.name))
						}
					})
			},
			FilterIndicators(option, label, search) {
				if (!search) return true
				const q = search.toLowerCase()
				const name = (option.name || '').toLowerCase()
				const professional_advice_description = (option.professional_advice_description || '').toLowerCase()
				const number = option.number || ''
				const uf_professional_advice = (option.uf_professional_advice || '').toLowerCase()
				const cpf = (option.cpf || '').replace(/\D/g, '')
				const qDigits = q.replace(/\D/g, '')
				return (
					name.includes(q) ||
					professional_advice_description.includes(q) ||
					number.includes(q) ||
					uf_professional_advice.includes(q) ||
					(qDigits.length > 0 && cpf.includes(qDigits))
				)
			},
			OnlyLetters(event) {
				event.target.value = event.target.value.replace(/[^a-zA-ZÀ-ÿ\s]/g, '')
				this.form.guardian_data.guardian_name = event.target.value
			},
			OnlyNumbers(event) {
				event.target.value = event.target.value.replace(/[^0-9]/g, '')
				this.form.patient_data.cns = event.target.value
			},
			SelectGuide(guide) {
				this.selectedGuide = guide
			},
			async OpenInvalidGroups() {
				let hasOpenedGroups = false

				if (!this.selectedPartnership) {
					this.open.partnership = true
					return true
				}

				for (const group in this.validations) {
					for (const field in this.form[group]) {
						if (this.validations[group][field] === false) {
							hasOpenedGroups = true
							this.open[group] = true
						}
					}
				}

				return hasOpenedGroups
			},
			OpenGroups() {
				if (!this.selectedPartnership) return

				for (const group in this.form) {
					this.OpenGroup(group)
				}

				if (this.isIndicatorRequired) this.open.indicator = true
			},
			async OpenGroup(group) {
				if (group === 'guardian_data' && this.isGuardianRequired) {
					this.open.guardian_data = true
				} else {
					for (const field in this.form[group]) {
						const isRequired = this.selectedPartnership[field] === true
						const isFilled = this.form[group][field] !== null && this.form[group][field] !== ''
						if (isRequired || isFilled) {
							this.open[group] = true
							break
						}
					}
				}
			},
			IsGroupValid(group) {
				if (!this.open[group]) return true

				for (const field in this.form[group]) {
					if (this.selectedPartnership[field] === true) {
						const value = this.form[group][field]
						if (!value || String(value).trim() === '') {
							return false
						}
					}
				}

				return true
			},
			GetInfoList(type) {
				return INFOS[type] || []
			},
			ConsultationGuideHandler() {
				const guideDisabledFields = [
					'authorization_data.authorization',
					'authorization_data.authorization_validity',
					'authorization_data.authorization_date',
					'authorization_data.main_guide_number',
					'patient_data.wallet_validity',
					'attendance_details.request_date',
					'indicator.indicator',
				]

				for (const field of guideDisabledFields) {
					const [group, subfield] = field.split('.')
					this.disabled[group][subfield] = true
				}

				this.ClearAuthorizationData(false)
				this.ClearIndicatorData()
				if (this.type === 'scheduling') this.ClearAttendanceDetailsData()
				if (this.isDifferentPartnership) this.ClearPatientData()
			},
			SpSadtGuideHandler() {
				for (const group in this.disabled) {
					for (const field in this.disabled[group]) {
						if (
							!this.isValidationCodeRequired &&
							group === 'authorization_data' &&
							(field === 'validation_code' || field === 'absence_justification')
						) {
							this.disabled[group][field] = true
							continue
						}
						this.disabled[group][field] = false
					}
				}

				if (!this.isDifferentPartnership && this.billing) {
					this.PopulateFormFromBilling(this.billing)
				}
			},
			ValidationCodeAndAbsenceHandler() {
				let validationCodeRequired = false

				if (this.selectedPartnership) {
					validationCodeRequired = this.selectedPartnership.validation_code
				}

				this.disabled.authorization_data.validation_code = !validationCodeRequired
				this.disabled.authorization_data.absence_justification = !validationCodeRequired
			},
			BillingTypeAndGuideHandler() {
				const partnershipBillingType = this.selectedPartnership?.billing_type
				const modalityGuides = this.modalities.find(m => m.id === this.modality_id)?.guides
				if (modalityGuides.length) {
					this.selectedGuide = modalityGuides.find(
						guide => guide.billing_type === partnershipBillingType
					)?.key
					return
				}

				const modality = this.modalities.find(m => m.id === this.modality_id)
				const moduleGuides = this.modules.find(m => m.id === modality.module_id)?.guides
				if (moduleGuides.length) {
					this.selectedGuide = moduleGuides.find(guide => guide.billing_type === partnershipBillingType)?.key
					return
				}

				this.selectedBillingType = 'default'
				this.selectedGuide = 'default'
			},
			ProviderGuideNumberHandler() {
				if (this.billing?.provider_guide_number && this.isTiss) {
					return (this.form.authorization_data.provider_guide_number = this.billing.provider_guide_number)
				}

				if (
					this.isTiss &&
					this.selectedPartnership?.provider_guide_number &&
					!this.billing?.provider_guide_number
				) {
					this.GenerateProviderGuideNumber()
				}
			},
			async GenerateProviderGuideNumber() {
				if (this.isPreAppointment || !this.isTiss) return
				if (!this.selectedPartnership?.provider_guide_number) return
				if (this.form?.authorization_data?.provider_guide_number) return

				this.StartLoading()

				return window.api
					.call('post', '/generate-provider-guide-number', {
						organization_id: this.requester_selected_id,
					})
					.then(({ data }) => {
						if (data?.response && data?.provider_guide_number) {
							this.form.authorization_data.provider_guide_number = String(data.provider_guide_number)

							this.UpdateBillingDebounce()
						}
					})
					.finally(() => {
						this.FinishLoading()
					})
			},
		},
		async beforeMount() {
			await this.PopulateFormFromBilling()
		},
		async mounted() {
			await this.GetIndicators()
			this.OpenGroups()
		},
	}
</script>

<style lang="scss" scoped>
	.section-header {
		display: flex;
		align-items: center;
		gap: 1rem;
		color: var(--fontColor);
		font-weight: 800;
		letter-spacing: 0.1em;
		margin-bottom: 2.5rem;

		&::before,
		&::after {
			content: '';
			flex: 1;
			height: 1px;
			background: var(--hr);
		}
	}

	.field-label {
		display: flex;
		align-items: center;
		text-transform: uppercase;
		font-size: 0.875rem;
		font-weight: 700;
		color: #64748b;
		margin-bottom: 6px;
		white-space: nowrap;
		padding: 0;
	}

	.select-button {
		background-color: var(--backgroundColorActiveNotSelected);
		border: solid 1px var(--borderColorActiveNotSelected);
		color: var(--fontColorActiveNotSelected);
		text-transform: uppercase;

		&::placeholder {
			color: var(--fontColorActiveNotSelected);
			opacity: 1;
		}

		option {
			color: var(--fontColorOptionHover);
			background-color: var(--optionBackgroundColor);
			text-transform: uppercase;

			&:hover {
				color: var(--fontColorOptionHover);
				background-color: var(--optionBackgroundColor);
			}
		}

		&:disabled {
			background-color: var(--disabledBackgroundColor) !important;
			border-color: var(--disabledBorderColor) !important;
			color: var(--disabledColor) !important;
		}
	}

	.form-control {
		text-transform: uppercase;

		&:focus {
			background-color: var(--backgroundColorActiveNotSelected);
			border: solid 1px var(--borderColorActiveNotSelected);
			color: var(--fontColor);
		}

		&::placeholder {
			color: var(--fontColorActiveNotSelected);
			opacity: 1;
		}

		&:not(:placeholder-shown) {
			background-color: var(--backgroundColorActiveSelected);
			border: solid 1px var(--newColor);
			color: var(--fontColorActiveSelected);
		}

		&:disabled {
			background-color: var(--disabledBackgroundColor) !important;
			border-color: var(--disabledBorderColor) !important;
			color: var(--disabledColor) !important;
			cursor: not-allowed;

			&::placeholder {
				color: var(--disabledColor) !important;
			}
		}
	}

	::v-deep .v-select {
		--vs-controls-color: var(--fontColorActiveNotSelected);
		--vs-border-color: var(--borderColorActiveNotSelected);
		--vs-border-width: 1px;
		--vs-border-radius: 8px;

		--vs-line-height: 1.4;
		--vs-font-size: 0.875rem;

		--vs-bg: var(--backgroundColorActiveNotSelected);
		--vs-selected-color: var(--fontColorActiveNotSelected);

		--vs-search-input-color: var(--fontColorActiveNotSelected);
		--vs-search-input-bg: var(--backgroundColorActiveNotSelected);
		--vs-search-input-placeholder-color: var(--fontColorActiveNotSelected);

		--vs-dropdown-bg: var(--optionBackgroundColor);
		--vs-dropdown-color: var(--fontColorOption);
		--vs-dropdown-box-shadow: 0 4px 16px rgba(0, 0, 0, 0.5);

		--vs-dropdown-option-padding: 4px 16px;
		--vs-dropdown-option-color: var(--fontColorOption);
		--vs-dropdown-option--active-bg: var(--optionBackgroundColor);
		--vs-dropdown-option--active-color: var(--fontColor);

		--vs-state-disabled-bg: var(--disabledBackgroundColor);
		--vs-state-disabled-color: var(--disabledColor);
		--vs-state-disabled-controls-color: var(--disabledColor);
		--vs-state-disabled-cursor: not-allowed;

		.vs__dropdown-toggle {
			background-color: var(--gridBackgroundColor);
			border-color: var(--elementsBorderColor);
			height: 3.438rem;
			padding: 0.6rem 1.2rem;
			align-items: center;
		}

		.vs__selected-options {
			align-items: center;
			flex-wrap: nowrap;
		}

		.vs__selected {
			margin: 0;
			padding: 0;
			color: var(--fontColorActiveSelected);
		}

		&.vs--open .vs__selected {
			color: var(--fontColorActiveNotSelected);
		}

		.vs__search,
		.vs__search:focus {
			color: var(--fontColorActiveNotSelected);
			background-color: transparent;
			font-size: 0.875rem;
			margin: 0;
			padding: 0;
			line-height: 1.5;
		}

		.vs__dropdown-menu {
			background-color: var(--optionBackgroundColor);
			border-color: var(--borderColorActiveNotSelected);
		}

		.vs__dropdown-option {
			color: var(--fontColorOption);
			font-size: var(--vs-font-size);

			&.vs__dropdown-option--highlight {
				background-color: var(--optionBackgroundColor) !important;
				color: var(--fontColorOptionHover);
			}
		}

		.vs__actions .vs__clear svg {
			width: 14px;
			height: 14px;
		}
	}

	::v-deep .v-select:has(.vs__selected) .vs__dropdown-toggle {
		background-color: var(--backgroundColorActiveSelected) !important;
		border-color: var(--newColor) !important;
		font-size: var(--vs-font-size) !important;
	}

	::v-deep .v-select:has(.vs__selected) .vs__selected {
		color: var(--fontColorActiveSelected) !important;
	}

	::v-deep .v-select:has(.vs__selected) .vs__search,
	::v-deep .v-select:has(.vs__selected) .vs__search:focus {
		color: var(--fontColorActiveSelected) !important;
	}

	::v-deep .v-select.vs--disabled {
		.vs__dropdown-toggle {
			background-color: var(--disabledBackgroundColor) !important;
			border-color: var(--disabledBorderColor) !important;
		}

		.vs__selected {
			color: var(--disabledColor) !important;
		}

		.vs__search,
		.vs__search::placeholder {
			color: var(--disabledColor) !important;
		}

		.vs__open-indicator {
			fill: var(--disabledColor) !important;
			background-color: var(--disabledBackgroundColor) !important;
		}
	}

	::v-deep .flatpickr-calendar {
		font-size: 1rem !important;
		scale: 0.99 !important;
		transform-origin: top left !important;
	}

	.info-button {
		padding: 0;
		border: none;
		background-color: transparent;
		cursor: pointer;

		i {
			font-size: 1.25rem;
			margin-top: 0.3rem;
			color: var(--fontInfoActive);
		}

		&:hover {
			i {
				color: var(--fontColorHover);
			}
		}

		&:disabled {
			cursor: default;

			i {
				color: var(--fontInfoInactive);
			}
		}
	}

	.info-anchor {
		position: relative;
		display: inline-flex;
		align-items: center;
	}

	.info-inline-popup {
		position: absolute;
		z-index: 200;
		top: calc(100% + 4px);
		left: 0;
		background-color: var(--tippyBackgroundColor);
		border: 1px solid var(--tippyBorderColor);
		border-radius: 0.5rem;
		padding: 0.75rem;
		width: 380px;
		max-width: calc(100vw - 16px);
		box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
		white-space: normal;

		&.info-inline-popup--up {
			top: auto;
			bottom: calc(100% + 4px);
		}
	}

	.cid-autocomplete {
		position: relative;
	}

	.cid-dropdown {
		position: absolute;
		z-index: 100;
		top: 100%;
		left: 0;
		right: 0;
		margin: 0;
		padding: 0;
		list-style: none;
		background-color: var(--optionBackgroundColor);
		border: 1px solid var(--borderColorActiveNotSelected);
		border-top: none;
		border-radius: 0 0 4px 4px;
		max-height: 220px;
		overflow-y: auto;
		box-shadow: 0 4px 16px rgba(0, 0, 0, 0.5);
	}

	.cid-option {
		padding: 6px 16px;
		color: var(--fontColorOption);
		cursor: pointer;
		font-size: 0.875rem;
		text-transform: uppercase;

		&:hover,
		&.cid-option--active {
			background-color: var(--optionBackgroundColor);
			color: var(--fontColorOptionHover);
		}
	}

	.btn-new-indicator {
		padding: 0.68rem 1rem;
		width: 2.25rem;
		height: 2.25rem;
	}

	.indicator-select-wrapper ::v-deep .vs__dropdown-toggle {
		border-top-right-radius: 0 !important;
		border-bottom-right-radius: 0 !important;
	}

	::v-deep .v-select.vs--error .vs__dropdown-toggle {
		border-color: #eab308;
	}

	::v-deep .v-select.vs--error.vs--open .vs__dropdown-toggle {
		border-color: var(--elementsBorderColor);
	}

	.date-wrapper--error ::v-deep .flatpickr-alt-input {
		border-color: #eab308;
	}

	.data-group {
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		gap: 1rem;
	}

	.grid-layout input.form-control:focus {
		background-color: var(--backgroundColorActiveSelected);
	}
</style>
